package one.healthium.url_provider.data

import one.healthium.url_provider.data.api.UrlProviderApiClient
import one.healthium.url_provider.domain.UrlProviderRepository
import one.healthium.url_provider.domain.UrlType

internal class AppUrlProviderRepository(
    private val urlProviderApiClient: UrlProviderApiClient,
) : UrlProviderRepository {

    private val cache = mutableMapOf<UrlType, String>()

    override suspend fun get(type: UrlType): String? {
        return cache[type] ?: fetchUrl(type)
    }

    private suspend fun fetchUrl(type: UrlType): String? {
        val legalUrls = urlProviderApiClient.getLegalUrls()
        legalUrls.forEach { dto ->
            val dtoType = UrlType.entries.firstOrNull { it.toDtoType() == dto.type }
            if (dtoType != null) {
                cache[dtoType] = dto.url
            }
        }
        return legalUrls.firstOrNull { dto -> dto.type == type.toDtoType() }?.url
    }
}

private fun UrlType.toDtoType(): String {
    return when (this) {
        UrlType.Terms -> "terms"
        UrlType.Privacy -> "privacy"
        UrlType.Legal -> "legal"
    }
}